<template>
  <AppLayout>
    <template #default>
      <h1>Renseignez votre nouveau mot de passe.</h1>
      <form @submit.prevent="handleSubmit">
        <FormInput
          id="reset-password"
          v-model="form.newPassword"
          :show-password="showPassword"
          autocomplete="new-password"
          label="Nouveau mot de passe"
          required
          type="password"
          @blur="$v.form.newPassword.$touch()"
          @toggle-password-visibility="showPassword = !showPassword"
        >
          <template #help>Doit contenir au minimum 8 caractères</template>
          <template v-if="$v.form.newPassword.$dirty" #error>
            <template v-if="!$v.form.newPassword.required">Veuillez entrer votre nouveau mot de passe</template>
            <template v-else-if="!$v.form.newPassword.minLength">8 caractères minimum</template>
          </template>
        </FormInput>

        <div class="submit">
          <ButtonGreen :busy="isSubmitting" :disabled="!canBeSubmitted" :icon="$icons.continue" type="submit">
            Continuer
          </ButtonGreen>
        </div>
      </form>
    </template>
  </AppLayout>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen.vue';
  import FormInput from '@/components/Form/FormInput.vue';
  import AppLayout from '@/components/AppLayout.vue';
  import { minLength, required } from '@byscripts/vuelidate/lib/validators';
  import Auth from '../../api/auth.js';

  export default {
    name: 'ForgottenPasswordPage',
    components: { AppLayout, FormInput, ButtonGreen },
    props: {
      token: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        form: {
          newPassword: null,
        },
        showPassword: true,
        isSubmitting: false,
      };
    },
    validations: {
      form: {
        newPassword: {
          required,
          minLength: minLength(8),
        },
      },
    },
    computed: {
      canBeSubmitted() {
        return !this.$v.$invalid;
      },
    },
    methods: {
      async handleSubmit() {
        try {
          this.isSubmitting = true;
          this.emailNotFound = false;
          this.showPassword = false;

          this.$v.$touch();

          if (this.$v.$invalid) {
            return this.$addError('Le formulaire contient des erreurs');
          }

          await Auth.resetPassword(this.token, this.form.newPassword);

          await this.$router.push({ name: 'reset-password-confirm' });
        } catch (e) {
          if (e.response?.json) {
            const response = await e.response.json();
            if (response.status_code === 404) {
              return this.$addError('Ce lien pour réinitialiser votre mot de passe n\'est pas valide. Veuillez effectuer une nouvelle demande.');
            }
            if (response.status_code === 401) {
              return this.$addError('Ce lien pour réinitialiser votre mot de passe n\'est plus valide. Veuillez effectuer une nouvelle demande.');
            }
          }

          await this.$addError('Une erreur inconnue s\'est produite');
          throw e;
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-input {
    margin-bottom: 3rem;
  }

  .submit {
    margin-top: 15rem;
    text-align: right;
  }
</style>
